import { Button } from './all'

export default function RenderAula({ item, tipo, handleAction = null }) {
  const iconsButton = {
    A: 'two_wheeler',
    B: 'directions_car',
    C: 'local_shipping',
    D: 'directions_bus',
    E: 'local_shipping',
  }

  return (
    <div className="
      bg-white border border-gray-200 rounded-2xl shadow-sm
      p-4 flex flex-col gap-3
      hover:shadow-md transition-all duration-200
    ">
      {/* Topo */}
      <div className="flex items-start gap-3">
        {/* Ícone */}
        <div className="bg-primary text-white rounded-xl p-3 flex items-center justify-center">
          <span className="material-icons text-2xl">
            {iconsButton[item.tipo] || 'event'}
          </span>
        </div>

        {/* Infos principais */}
        <div className="flex-1 text-sm flex flex-col gap-1 justify-start items-start">
          {tipo !== 1 && (
            <p className="text-gray-700">
              <span className="font-semibold">Data:</span> {item.data}
            </p>
          )}

          <p className="text-gray-700">
            <span className="font-semibold">Hora:</span> {item.hora}
          </p>

          {tipo === 1 ? (
            <p className="capitalize text-gray-800">
              <span className="font-semibold">Aluno:</span>{' '}
              {`${item.nome} ${item.sobrenome}` || 'Não especificado'}
            </p>
          ) : (
            <p className="capitalize text-gray-800">
              <span className="font-semibold">Instrutor:</span>{' '}
              {item.nome_instrutor || 'Não especificado'}
            </p>
          )}

          {tipo === 1 && (
            <p className="text-gray-700">
              <span className="font-semibold">Veículo:</span>{' '}
              {`${item.placa} ${item.modelo}`}
            </p>
          )}
        </div>

        {/* Badge lateral (tipo instrutor) */}
        {tipo === 1 && (
          <div className="
            flex flex-col items-center justify-center
            bg-primary/10 text-primary
            rounded-xl px-3 py-2 min-w-[80px]
          ">
            <span className="text-xs uppercase tracking-wide">Autoescola</span>
            <span className="text-2xl font-bold leading-none">
              {item.autoescola_id}
            </span>
          </div>
        )}
      </div>

      {/* Ações */}
      {tipo !== 1 && (
        <div className="pt-2 border-t border-gray-100 flex justify-end">
          <Button type={3} onClick={() => handleAction && handleAction('Excluir', item)}>
            Cancelar
            <span className="material-icons">delete</span>
          </Button>
        </div>
      )}
    </div>
  )
}
